<div class="dialog-box">
    <!-- header modal -->
    <div class="mb-1 d-flex justify-content-start align-items-center flex-column">
        <div class="col-12 title-container d-flex justify-content-between align-items-center flex-row">
            <p class="modal-title mb-3">{{ 'app.wizard.stepper_ia.dialogs.regenerate-site.title' | translate }}</p>
            <i class="fa fa-times cursor-pointer mb-3" aria-hidden="true" (click)="closeDialog()"></i>
        </div>

        <div class="col-12 mt-3">
            <p class="modal-subtitle">
                {{ 'app.wizard.stepper_ia.dialogs.regenerate-site.subtitle' | translate }}
                <i class="fa-solid fa-sparkles color-sparkles"></i>
            </p>
        </div>
    </div>

    <!-- body modal -->
    <div class="no-gutters mb-3">
        <form [formGroup]="contentForm" *ngIf="contentForm">
            <div class="position-relative mb-3">
                <textarea
                    name="description"
                    class="w-100 text-area form-control"
                    autocomplete="off"
                    formControlName="promptUsuario"
                    rows="5"
                    maxlength="300"
                    placeholder="{{ params.prompt }}"
                    style="padding-bottom: 3rem"
                ></textarea>

                <div class="d-flex align-items-center position-absolute" style="bottom: 0.75rem; left: 0.75rem">
                    <voice-recorder
                        (transcript)="contentForm.get('promptUsuario').setValue($event)"
                        [showTextArea]="false"
                        [showBorders]="false"
                    >
                    </voice-recorder>
                </div>
            </div>

            <div class="mb-3">
                <small class="text-muted">
                    {{ 'app.wizard.stepper_ia.dialogs.regenerate-site.la_ia_puede' | translate }}
                </small>
            </div>
        </form>

        <div
            class="notification-alert rounded d-flex align-items-center p-3"
            [ngClass]="{
                info: params?.triesCount < params?.totalTries,
                warning: params?.triesCount >= params?.totalTries
            }"
        >
            <i
                class="fal fa-info-circle mr-2"
                [ngClass]="{
                    info: params?.triesCount < params?.totalTries,
                    warning: params?.triesCount >= params?.totalTries
                }"
            ></i>
            <p class="mb-0" [innerHTML]="actionsCountText"></p>
        </div>
    </div>

    <!-- footer modal -->
    <div class="d-flex justify-content-between align-items-center mt-4 pb-3 gap-3 align-self-end">
        <button class="btn btn-continue regenerate px-4 py-2 mr-2" (click)="closeDialog()">
            {{ 'app.wizard.stepper_ia.dialogs.regenerate-site.button.cancel' | translate }}
        </button>
        <button
            class="btn btn-continue px-4 py-2 d-flex align-items-center"
            (click)="updatePrompt()"
            [disabled]="contentForm?.invalid"
        >
            <i class="fa-solid fa-sparkles mr-2"></i>
            {{ 'app.wizard.stepper_ia.dialogs.regenerate-site.button.create' | translate }}
        </button>
    </div>
</div>
